'use client'

import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { useFormField } from '../../hooks/useFormField'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>Form control wrapper that sets appropriate aria attributes for accessibility.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormControl } from '@shared/ui'
 * 
 * <FormControl>
 *   <Input type="email" />
 * </FormControl>
 * ```
 */
export const FormControl = React.forwardRef<
  React.ComponentRef<typeof Slot>,
  React.ComponentProps<typeof Slot>
>(({ ...props }, ref) => {
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField()

  return (
    <Slot
      ref={ref}
      id={formItemId}
      aria-describedby={
        !error ? formDescriptionId : `${formDescriptionId} ${formMessageId}`
      }
      aria-invalid={!!error}
      {...props}
    />
  )
})
FormControl.displayName = 'FormControl' 